import { create, type StateCreator } from "zustand"
import { PRODUCT_TOUR_V2_STEPS } from "../types/steps"
import { createJSONStorage, persist } from "zustand/middleware"

interface ProductTourV2State {
  currentStep: PRODUCT_TOUR_V2_STEPS
  isActive: boolean
  setCurrentStep: (currentStep: PRODUCT_TOUR_V2_STEPS) => void
  setIsActive: (isActive: boolean) => void
}

const state: StateCreator<ProductTourV2State> = (set) => ({
  currentStep: PRODUCT_TOUR_V2_STEPS.STUDY,
  isActive: false,
  setCurrentStep: (currentStep: PRODUCT_TOUR_V2_STEPS) => set({ currentStep }),
  setIsActive: (isActive: boolean) => set({ isActive }),
})

export const useProductTourV2 = create<ProductTourV2State>()(
  persist(state, {
    name: "@tuni/product-tour-v2",
    storage: createJSONStorage(() => localStorage),
  }),
)
